export default __webpack_public_path__ + "static/media/coins.cc024fe6.svg";